// extracted by mini-css-extract-plugin
export default {"floaty":"FloatyImage_floaty__Qb8af"};